export default "__VITE_ASSET__95b63bfa__"